import { render, staticRenderFns } from "./VerifyHomestayActi.vue?vue&type=template&id=1060c8ec&scoped=true"
import script from "./VerifyHomestayActi.vue?vue&type=script&lang=js"
export * from "./VerifyHomestayActi.vue?vue&type=script&lang=js"
import style0 from "./VerifyHomestayActi.vue?vue&type=style&index=0&id=1060c8ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1060c8ec",
  null
  
)

export default component.exports